// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== TabAvisDocuments — EPIC-15 / Story 15.5 =========================== */

/* ── Section Avis — grille de champs ─────────────────────────────────────── */

.avis-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem 2rem;
}

@media (max-width: 768px) {
  .avis-grid {
    grid-template-columns: 1fr;
  }
}

.avis-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.avis-field label {
  font-size: 1.2rem;
  color: #6b7280;
  font-weight: 500;
}

.avis-field span {
  font-size: 1.3rem;
  color: #374151;
  background-color: #f9fafb;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
}

/* ── Section Documents — etats de chargement ─────────────────────────────── */

.docs-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem;
  color: #6b7280;
  font-size: 1.3rem;
}

.docs-error {
  padding: 1.5rem;
  color: #ef4444;
  font-size: 1.3rem;
}

.docs-empty {
  padding: 2rem;
  color: #9ca3af;
  font-size: 1.4rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/TabAvisDocuments.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E,+EAA+E;;AAE/E;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* ===== TabAvisDocuments — EPIC-15 / Story 15.5 =========================== */\n\n/* ── Section Avis — grille de champs ─────────────────────────────────────── */\n\n.avis-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.2rem 2rem;\n}\n\n@media (max-width: 768px) {\n  .avis-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.avis-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.avis-field label {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.avis-field span {\n  font-size: 1.3rem;\n  color: #374151;\n  background-color: #f9fafb;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n}\n\n/* ── Section Documents — etats de chargement ─────────────────────────────── */\n\n.docs-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1.5rem;\n  color: #6b7280;\n  font-size: 1.3rem;\n}\n\n.docs-error {\n  padding: 1.5rem;\n  color: #ef4444;\n  font-size: 1.3rem;\n}\n\n.docs-empty {\n  padding: 2rem;\n  color: #9ca3af;\n  font-size: 1.4rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
